<template>
	<date-picker
		:class="{ 'date-component-round': round }"
		:disabled="disabled"
		:input-attr="inputAttr"
		:value="date"
		:placeholder="placeholderGenerate"
		format="YYYY-MM-DD"
		value-type="YYYY-MM-DD"
		@input="$emit('on-input', $event)"
	>
		<template v-if="showIcon">
			<img
				class="icon-calendar-custom"
				slot="icon-calendar"
				:src="icon"
			/>
		</template>
	</date-picker>
</template>

<script>
	import DatePicker from 'vue2-datepicker';
	import 'vue2-datepicker/index.css';
	import 'vue2-datepicker/locale/es';

	function inputAttr() {
		return {
			tabindex: this.tabindex,
		};
	}

	function placeholderGenerate() {
		return this.placeholder || 'aaaa-mm-dd';
	}

	export default {
		name: 'date-component',
		components: {
			DatePicker,
		},
		computed: {
			inputAttr,
			placeholderGenerate,
		},
		props: {
			date: [Date, String],
			disabled: {
				default: false,
				type: Boolean,
			},
			icon: String,
			placeholder: String,
			round: {
				default: false,
				type: Boolean,
			},
			showIcon: {
				default: true,
				type: Boolean,
			},
			tabindex: [String, Number],
		},
	};
</script>

<style lang="scss" scoped>
	.icon-calendar-custom {
		height: 15px;
	}
	.mx-datepicker {
		max-width: 100% !important;
	}

	.mx-input {
		height: 31px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/autocomplete/date-component-dashboard.vue